import { useMemo } from 'react'
import { StoreCalendarType } from 'types/storeCalendar'
import { DayOfWeekType, DaysOfWeek } from 'lib/daysOfWeek'
import { SpecialHolidayType } from 'types/calendar'
import { parseToDate } from 'lib/helper'
const daysOfWeek = new DaysOfWeek()

// 臨時休業日として設定された日付を取得
const useConfirmCloseStoreCalendars = (
  confirmStoreCalendars: StoreCalendarType[],
  storeCalendars: StoreCalendarType[],
  holidays: DayOfWeekType[],
  specialHolidays: SpecialHolidayType[]
) => {
  return useMemo(() => {
    // 臨時休業日として追加された日付
    const closeStoreCalendars = confirmStoreCalendars.filter((confirmStoreCalendar) => {
      return (
        confirmStoreCalendar.status === 'close' &&
        !storeCalendars.some((_storeCalendar) => {
          return _storeCalendar.date === confirmStoreCalendar.date
        })
      )
    })

    // 臨時営業日から定休日になった日付
    const holidayCalendars = confirmStoreCalendars.filter((confirmStoreCalendar) => {
      return (
        confirmStoreCalendar.status === '' &&
        holidays.includes(daysOfWeek.getDayOfWeek(parseToDate(confirmStoreCalendar.date), specialHolidays))
      )
    })

    return [...closeStoreCalendars, ...holidayCalendars]
  }, [confirmStoreCalendars, storeCalendars, holidays, specialHolidays])
}

export default useConfirmCloseStoreCalendars
